<nz-modal
		[nzMaskClosable]="false"
		nzTitle="{{ 'workflow.modal.missing_value.title' | translate }}"
		(nzOnOk)="emitOK()"
		(nzOnCancel)="closeMissingValueModal()"
		[nzVisible]="showMissingValueModal"
		nzOkText="{{ 'actions.OK' | translate }}"
		nzCancelText="{{ 'actions.cancel' | translate }}"
>
	{{ 'workflow.modal.missing_value.text' | translate }}
</nz-modal>
